import Vue from 'vue'
import Vuex from 'vuex'
import pathify, { make } from 'vuex-pathify'

pathify.options.mapping = 'simple'

const getDefaultState = () => ({
  test: 'ทดสอบ',
})
const dataLogin = () => ({
  infoLogin: {
    Name: 'กำลัง',
    Surname: 'ทดสอบระบบ',
  },
})
const state = Object.assign(getDefaultState(), dataLogin())

const mutations = make.mutations(state)
const resetMutation = {
  resetState(states) {
    Object.assign(states, getDefaultState());
  },
}
Object.assign(mutations, resetMutation);

const actions = make.actions(state)
const getters = make.getters(state);

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
  },
  plugins: [
    pathify.plugin,
  ],
  state,
  mutations,
  actions,
  getters,
})
